var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { SetIgVersionModalData } from './set.ig.version.modal.provider';
var SetIgVersionModalComponent = /** @class */ (function (_super) {
    __extends(SetIgVersionModalComponent, _super);
    function SetIgVersionModalComponent(fb, accountApiService, alertify, formBuilder, modalService, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.accountApiService = accountApiService;
        _this.alertify = alertify;
        _this.formBuilder = formBuilder;
        _this.modalService = modalService;
        _this.dialogRef = dialogRef;
        _this.loading = false;
        _this.version = {
            event: {
                version: 'V2',
            },
            place: {
                version: 'V2',
            },
            tripPlanner: {
                version: 'V2',
            },
            clientDashboard: {
                version: 'V2',
            },
        };
        // public isAreaBusiness = false;
        _this.businessType = 'normal';
        _this.isUseIgDefaultCustomPlaceCategories = true;
        _this.showPlaceImageCount = 5;
        _this.initial = 'facebook';
        _this.googleKey = '';
        _this.blockCategories = '';
        _this.account = Object.assign({}, data);
        return _this;
    }
    SetIgVersionModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this.formBuilder.group({
            googleKey: [null, null],
            blockCategories: [null, null],
        });
        this.loading = true;
        this.accountApiService.getIgVersion(this.account.account.userName).subscribe(function (version) {
            if (version && version.event) {
                _this.version = version;
            }
            _this.loading = false;
        });
    };
    SetIgVersionModalComponent.prototype.setIgEventVersion = function () {
        var _this = this;
        this.accountApiService.setIgVersion(this.account.account.userName, this.version).subscribe(function (version) {
            _this.alertify.successfully('Set version');
        });
    };
    SetIgVersionModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return SetIgVersionModalComponent;
}(BaseComponent));
export { SetIgVersionModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/set.ig.version/set.ig.version.modal.component.ts.pre-build-optimizer.js